import { render, staticRenderFns } from "./qrCodeLink.vue?vue&type=template&id=f2f964b2&scoped=true&"
import script from "./qrCodeLink.vue?vue&type=script&lang=js&"
export * from "./qrCodeLink.vue?vue&type=script&lang=js&"
import style0 from "./qrCodeLink.vue?vue&type=style&index=0&id=f2f964b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f964b2",
  null
  
)

export default component.exports